import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../hooks/api';

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/api/auth/request-password-reset', { email });
    } catch {
      // Intentional: always show success to prevent account enumeration
    } finally {
      setLoading(false);
      setSent(true);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <img src="/logo.png" alt="AB Jewels" className="login-logo-img" />
        <p className="login-subtitle">Reset your password</p>

        {sent ? (
          <>
            <div className="alert alert-success">
              If an account exists with that email, a reset link has been sent. Check your inbox (and spam folder).
            </div>
            <p style={{ textAlign: 'center', marginTop: 14, fontSize: 13 }}>
              <Link to="/login" style={{ color: 'var(--text-muted)' }}>Back to sign in</Link>
            </p>
          </>
        ) : (
          <>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 16, textAlign: 'center' }}>
              Enter your email and we'll send you a link to reset your password.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} required autoFocus />
              </div>
              <button className="btn btn-primary btn-block" disabled={loading || !email}>
                {loading ? 'Sending…' : 'Send reset link'}
              </button>
            </form>
            <p style={{ textAlign: 'center', marginTop: 14, fontSize: 13 }}>
              <Link to="/login" style={{ color: 'var(--text-muted)' }}>Back to sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
